import { LocaleString } from './LocaleString';

// Schema: https://github.com/Global-eCom/sanity-studio-cms/blob/main/studio/schemas/documents/Tag.ts

export const LocaleTag = (field: string): string => `
  ${field} {
    "value": value.current,
    ${LocaleString('label')},
  }
`;
